module.exports = __webpack_public_path__ + "media/images/icons/tiktok-008561d25c47b1a4bd7fad683c309630.png";